import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import axios from 'axios' // remove comment if yu needed
import app from '@/main' // import the instance
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'

const model = (payload) => ({
  id: payload.id,
  date: moment(payload.date).format('YYYY-MM-DD'),
  conceptable_type: payload.conceptable_type,
  conceptable_id: payload.conceptable_id,
  concept: payload.concept,
  payment: payload.payment || 0,
  charge: payload.charge || 0,
  status: payload.status
})
var crud = new Crud('Concepts', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  concepts: []
}

const mutations = {
  ...crud.mutations,
  UPDATE_RECORDS (state, payload) {
    const idx = state.concepts.findIndex(u => u.id === payload.id)
    state.concepts[idx] = payload
    if (idx >= 0) {
      Vue.set(state.concepts, idx, payload)
    }
  },
  SET_CONCEPTS (state, payload) {
    state.concepts.unshift(payload)
  },
  DELETE_CONCEPT (state, payload) {
    const idx = state.concepts.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.concepts, idx)
    }
  }
}

const actions = {
  ...crud.actions,
  addConcept ({ commit }, payload) {
    commit('SET_CONCEPTS', payload)
  },
  editConcept ({ commit }, payload) {
    commit('UPDATE_RECORDS', payload)
  },
  async loadRecords ({ commit, state }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(
        `concepts?page=${payload.page}${state.filterParams}`
      )
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async editRecord ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.put(`concepts/${payload.id}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('UPDATE_RECORDS', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.concepts',
            text: 'front.updated_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteRecord ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`concepts/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit(`DELETE_CONCEPT`, payload)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: `strings.concepts`,
            text: 'front.deleted_successfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  concepts: state => state.concepts
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
